import * as ApiManager from './_manager';
import store from '@/store';

export const consumer = {
  get: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/get`,
      payload
    );
  },
  update: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/update`,
      payload
    );
  },

  getConsumerList: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/list`,
      payload
    );
  },

  getAllConsumerList: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/list?page=${payload.page ? payload.page : 1}`,
      payload,
      false
    );
  },

  showPassword: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/show_password`,
      payload
    );
  },

  sendReminders: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/send_reminders`,
      payload
    );
  },

  detachConsumer: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/detachConsumer`,
      payload
    );
  },

  detachAllConsumer: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/detachAllConsumer`,
      payload
    );
  },

  createByAdmin: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/create`,
      payload
    );
  },

  refund: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/refund`,
      payload
    );
  },

  exportReport: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/` +
        payload.consumer_id +
        `/exportReport`,
      payload
    );
  },

  exportAllConsumersReport: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/consumer/exportAllConsumersReport`,
      payload
    );
  },

  redeemCoupon: payload => {
    return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/consumer/coupon/check_coupon`, payload);
  },
};
